module.exports = __webpack_public_path__ + "static/media/money-bill-wave-alt.fcf07b26.svg";